export const CHANGE_VISIBILITY_CHATICON = 'CHANGE_VISIBILITY_CHATICON';
